// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/account.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { User } from "./user_pb";
import { Agent } from "../../common/v1/common_pb";

/**
 * @generated from message msh.resource.v1.Account
 */
export const Account = proto3.makeMessageType(
  "msh.resource.v1.Account",
  () => [
    { no: 5, name: "consumer", kind: "message", T: Account_Consumer, oneof: "type" },
    { no: 6, name: "business", kind: "message", T: Account_Business, oneof: "type" },
  ],
);

/**
 * @generated from message msh.resource.v1.Account.Consumer
 */
export const Account_Consumer = proto3.makeMessageType(
  "msh.resource.v1.Account.Consumer",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner", kind: "message", T: User },
    { no: 4, name: "users", kind: "message", T: User, repeated: true },
    { no: 5, name: "creation_time", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "message", T: Agent },
  ],
  {localName: "Account_Consumer"},
);

/**
 * @generated from message msh.resource.v1.Account.Business
 */
export const Account_Business = proto3.makeMessageType(
  "msh.resource.v1.Account.Business",
  () => [
    { no: 1, name: "account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "managers", kind: "message", T: User, repeated: true },
    { no: 4, name: "users", kind: "message", T: User, repeated: true },
    { no: 5, name: "creation_time", kind: "message", T: Timestamp },
    { no: 6, name: "created_by", kind: "message", T: Agent },
  ],
  {localName: "Account_Business"},
);

